import { useEffect, useState } from 'react'
import DynamicDownloadBtnSection from '../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection'
import "./Aishe.scss";
import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';

const Aishe = () => {

    const { backendUrl } = useContext(AppContext);
    const [allAisheReports, setAllAisheReports] = useState([]);
    let errorShown = false;

    async function fetchAllAisheReports() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllAishe`);
            if (data.success) {
                setAllAisheReports(data || []);
            }
            errorShown = false;
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }

            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        }
    }

    useEffect(() => {
        fetchAllAisheReports();
    }, []);

    const content = allAisheReports?.reports
        ?.filter(item => item.isActive)
        .map(item => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];


    return (
        <section className="aischeMainContainer">
            <header className="aischeHeader">
                <h2>AISHE</h2>
            </header>
            <DynamicDownloadBtnSection
                items={content}
                yearFontSize={1.25}
            />
        </section>
    )
}

export default Aishe;
